<template>
    <button type="button" class="fns ta-c br-s ath-popover-trigger" @click="open">{{ uiSign }}</button>
</template>

<script>
import { isObject } from '@aretheyhappy/utils';

export default {
    name: 'mead-popover-trigger',
    props: {
        /**
         * Data passed to the popover when it opens, either merged into the
         * plain-config payload or set on a `PopoverConfig` instance via
         * `setPopoverData`. Pass `false` to open with no data.
         */
        data    : {type: [Object, Boolean], default: () => false},
        /**
         * When true, prevents the triggering event from propagating/escaping
         * further (via `DomUtils.preventImmediateEventEscape`) after opening
         * the popover.
         */
        prevent : {type: Boolean, default: () => false},
        /**
         * Popover configuration: either a `PopoverConfig` instance (opened via
         * `PopoverService.openPopover`) or a plain config object (opened via
         * `PopoverService.open`).
         */
        cfg     : {type: Object, default: () => ({})},
        /**
         * The character/text displayed on the trigger button (e.g. '?').
         */
        uiSign  : {type: String, default: '?'},
    },
    methods: {
        open: function (event) {
            if (this.cfg.constructor?.name === MeadCommon.PopoverConfig.name) {
                this.cfg.setEvent(event)
                    .setPopoverData(this.data)

                MeadCommon.PopoverService.openPopover(this.cfg);
            } else {
                MeadCommon.PopoverService.open(
                    this.cfg,
                    event,
                    Object.assign({}, isObject(this.data) ? this.data : {})
                );
            }

            if (this.prevent === true) {
                MeadCommon.DomUtils.preventImmediateEventEscape(event);
                return false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@use '../../../sass/variables' as *;

$self-dim: 2rem;

button {
    width: $self-dim;
    height: $self-dim;
    line-height: $self-dim;
    font-weight: 700;
    font-family: $ff-b;
    background-color: var(--c-brand-default-bg);
    color: var(--c-brand-default-fg);
    box-shadow: none;
    border: none;
    cursor: pointer;
    font-size: $fs-s;

    &:hover {
        background-color: var(--c-brand-active-bg);
        color: var(--c-brand-active-fg);
    }
}
</style>
